import { isNotNull, OrganizationDetailFragment, WorkLocationFragment } from '@alice-financial/alice-sdk'
import { Box, Grid, HealthcheckList, InertHealthcheckItem } from '@alice-financial/pretext-ui'
import * as React from 'react'

import { CreateEditWorkLocationButton } from './WorkLocationForm'
import { WorkLocationItem } from './WorkLocationItem'

type WorkLocationListProps = {
  org?: OrganizationDetailFragment | null
}

export const WorkLocationList: React.FC<WorkLocationListProps> = ({ org }: WorkLocationListProps) => {
  if (!org) return null
  const locations = org.workLocations.filter(isNotNull).sort((a, b) => {
    const displayName = (location: WorkLocationFragment) => location.name
    return displayName(a).localeCompare(displayName(b))
  })

  return (
    <>
      <Healthchecks org={org} />
      <Grid container component="ul" spacing={3} pl={0} sx={{ position: 'relative' }}>
        {locations.length > 0 &&
          locations.map((location) => (
            <Grid component="li" size={{ xs: 12, sm: 12 }} sx={{ listStyle: 'none' }} key={location.id}>
              <WorkLocationItem org={org} location={location} />
            </Grid>
          ))}
        <Grid component="li" size={{ xs: 12, sm: 12 }} container sx={{ listStyle: 'none' }}>
          <CreateEditWorkLocationButton org={org} />
        </Grid>
      </Grid>
    </>
  )
}

type HealthchecksProps = {
  org: OrganizationDetailFragment
}
const Healthchecks = ({ org }: HealthchecksProps) => {
  const locations = org.workLocations.filter(isNotNull)
  const hasLocations = locations.length > 0

  const locationsWithoutPayGroups = locations.filter((location) => !location.employersInfo?.length)
  const hasLocationWithoutPayGroup = locationsWithoutPayGroups.length > 0
  const hasHealthchecks =
    hasLocationWithoutPayGroup ||
    org.employers.length > 1 ||
    (hasLocations && !org.payrollConnection.payrollConnectedAt)
  if (!hasHealthchecks) {
    return null
  }
  return (
    <>
      <Box maxWidth="sm">
        <HealthcheckList sx={{ mb: 3 }} todo>
          {hasLocations
            ? hasLocationWithoutPayGroup && (
                <InertHealthcheckItem
                  status="incomplete"
                  primary={`Assign a pay group to location${locationsWithoutPayGroups.length > 1 ? 's' : ''}`}
                  todo
                  secondary={
                    <Box>
                      <ul>
                        {locationsWithoutPayGroups.map((location) => (
                          <li key={location.id}>{location.name}</li>
                        ))}
                      </ul>
                    </Box>
                  }
                />
              )
            : null}
        </HealthcheckList>
      </Box>
    </>
  )
}
